import SvgIcon from '@/components/SvgIcon';

const svg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.82 13.28L11.82 11.28C12.6754 10.0713 13.0459 8.58547 12.8582 7.1166C12.6704 5.64773 11.9381 4.30287 10.8061 3.34817C9.67413 2.39347 8.22499 1.89851 6.7455 1.96124C5.26601 2.02398 3.86398 2.63984 2.81688 3.68694C1.76978 4.73403 1.15392 6.13607 1.09119 7.61556C1.02845 9.09505 1.52341 10.5442 2.47811 11.6762C3.43281 12.8081 4.77767 13.5405 6.24654 13.7282C7.71542 13.916 9.20125 13.5455 10.41 12.69L12.41 14.69C12.6013 14.8539 12.8474 14.9395 13.099 14.9298C13.3507 14.92 13.5895 14.8157 13.7675 14.6376C13.9456 14.4595 14.05 14.2208 14.0597 13.9691C14.0694 13.7174 13.9838 13.4713 13.82 13.28ZM4.29999 10.66C3.75975 10.1184 3.39215 9.42883 3.24362 8.6784C3.0951 7.92796 3.17232 7.15034 3.46552 6.44377C3.75872 5.7372 4.25475 5.13337 4.89096 4.70856C5.52716 4.28376 6.27499 4.05704 7.03999 4.05704C7.80498 4.05704 8.55281 4.28376 9.18901 4.70856C9.82522 5.13337 10.3213 5.7372 10.6145 6.44377C10.9077 7.15034 10.9849 7.92796 10.8363 8.6784C10.6878 9.42883 10.3202 10.1184 9.77999 10.66C9.05264 11.3855 8.06728 11.7929 7.03999 11.7929C6.0127 11.7929 5.02733 11.3855 4.29999 10.66Z"
        fill="currentColor"
      />
    </svg>
  );
};
const SearchIcon = (props) => {
  return <SvgIcon component={svg} {...props} />;
};
export default SearchIcon;
